import { Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsIn,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import { CounterRegisterIngredientLineDto } from './public-counter-register-line.dto';
import { STORAGE_CONDITIONS, type StorageCondition } from './storage-condition.enum';

/**
 * One menu-item card of the public register (plan.md W4.2: "una scheda per
 * voce di menu con codice, denominazione, elenco completo con evidenze,
 * conservazione, note"). Built from the last confirmed snapshot only, never
 * from live state.
 */
export class PublicCounterRegisterEntryDto {
  @IsString()
  @IsNotEmpty()
  code!: string;

  @IsString()
  @IsNotEmpty()
  legalName!: string;

  @IsOptional()
  @IsIn(STORAGE_CONDITIONS)
  storageCondition?: StorageCondition;

  @IsOptional()
  @IsNumber()
  storageTemperatureMinC?: number;

  @IsOptional()
  @IsNumber()
  storageTemperatureMaxC?: number;

  @IsOptional()
  @IsString()
  storageNote?: string;

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  legalNotices?: string[];

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => CounterRegisterIngredientLineDto)
  ingredientLines!: CounterRegisterIngredientLineDto[];

  /** Definitive allergen declarations (`CONTAINS`), separate from traces. */
  @IsOptional()
  @IsString()
  containsNote?: string;

  /** Some ingredient has no allergen declaration: "da verificare", not "none". */
  @IsOptional()
  @IsBoolean()
  allergensUnverified?: boolean;

  /** Possible cross-contamination traces (`MAY_CONTAIN`). */
  @IsOptional()
  @IsString()
  mayContainNote?: string;
}
